export enum CompanyInfoItemStatus {
  NOT_STARTED = 'Not started',
  READY_FOR_REVIEW = 'Ready for final review',
  READY_TO_DISTRIBUTE = 'Ready to distribute',
  PENDING_RESPONSE = 'Pending response',
  COMPLETE = 'Complete',
}
